import { INTERNAL_LINKS } from "@/lib/helpers/urls";

export const UNAUTHED_NAVBAR_LINKS = [
  {
    href: INTERNAL_LINKS.PRICES,
    label: "prices",
    prefetch: true,
    comingSoon: false,
  },
  {
    href: INTERNAL_LINKS.DOCS.HOME,
    label: "docs",
    prefetch: true,
    comingSoon: false,
  },
  {
    href: INTERNAL_LINKS.CONTACT,
    label: "contact us",
    prefetch: false,
    comingSoon: false,
  },
  {
    href: INTERNAL_LINKS.ABOUT,
    label: "about",
    prefetch: false,
    comingSoon: false,
  },
];
